import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import VacationApplicationsListPage from './pages/VacationApplicationsListPage';
import VacationApplicationsDetailPage from './pages/VacationApplicationsDetailPage';
import DayOffApplicationsListPage from './pages/DayOffApplicationsListPage';
import DayOffApplicationsDetailPage from './pages/DayOffApplicationsDetailPage';

const VacationModule: React.FC = () => {
  return (
    <Routes>
      <Route path="/applications" element={<VacationApplicationsListPage />} />
      <Route path="/applications/:applicationId" element={<VacationApplicationsDetailPage />} />
      <Route path="/day-off" element={<DayOffApplicationsListPage />} />
      <Route path="/day-off/:applicationId" element={<DayOffApplicationsDetailPage />} />
      <Route path="/" element={<Navigate to="/vacation/applications" replace />} />
      <Route path="*" element={<Navigate to="/vacation/applications" replace />} />
    </Routes>
  );
};

export default VacationModule;
